import React from "react";

const Button = ({children,className, ...rest}) => {
  return (
    <button
    {...rest}
     className={`w-fit wave-effect overflow-hidden dark:text-white py-3 px-8 border dark:border-zinc-200/50 border-zinc-700/50 ${className} pointer-events-auto`}>
      {children}
    </button>
  );
};

export default Button;
